module.exports = __webpack_public_path__ + "static/img/qrcode.9102327a.png";